"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3157],{

/***/ 13704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventListener; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Adds event listener to a given element.
 *
 * @param {HTMLElement} element Element to attach the listener to
 * @param {string} type Event type
 * @param {Function} listener Event listener
 */

function useEventListener(element, type, listener) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!element) {
      return undefined;
    }

    element.addEventListener(type, listener);
    return function () {
      element.removeEventListener(type, listener);
    };
  }, [element, type, listener]);
}

/***/ }),

/***/ 46676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var BUTTER_CLIENT_VERSION = '1.2.5';

var axios = __webpack_require__(9669);

var resources = {
  Post: __webpack_require__(60445),
  Category: __webpack_require__(8402),
  Tag: __webpack_require__(9210),
  Author: __webpack_require__(8306),
  Feed: __webpack_require__(1863),
  Content: __webpack_require__(5986),
  Page: __webpack_require__(16288)
}

function Butter(apiToken, testMode, timeout, axiosHook) {
  if (!(this instanceof Butter)) {
    return new Butter(apiToken, testMode, timeout, axiosHook);
  }

  if (!apiToken) {
    throw 'ButterCMS API token not set';
  }

  // Use live mode by default
  var testMode = testMode || false;

  // 3000ms timeout by default
  var timeout = timeout || 3000;

  var requestMethods = this._prepMethods(apiToken, testMode, timeout, axiosHook);

  this._prepResources(requestMethods);
}

Butter.prototype = {
  _prepResources: function(requestMethods) {
    for (var name in resources) {
      this[
        name[0].toLowerCase() + name.substring(1)
      ] = new resources[name](requestMethods);
    }
  },
  _prepMethods: function(apiToken, testMode, timeout, axiosHook) {
    return {
      get: function(url, params) {
        var headers = {'X-Butter-Client': 'JS/' + BUTTER_CLIENT_VERSION}
        // detect if library is called in server side
        if (typeof window === 'undefined'){
          headers['Accept-Encoding'] = 'gzip'
        }
        var conn = axios.create({
          baseURL: 'https://api.buttercms.com/v2',
          timeout: timeout,
          headers: headers
        });

        if (axiosHook) {
          axiosHook(conn)
        }

        var params = params || {};

        // Add api token to query string
        params.auth_token = apiToken;

        // Append &test=1&preview=1 query strings
        if (testMode) {
          params.test = 1
          params.preview = 1
        }

        return conn.get(url, {params: params})
      }
    }
  }
}

module.exports = Butter;


/***/ }),

/***/ 8306:
/***/ (function(module) {



function Author(conn) {
  this._conn = conn;
}

Author.prototype = {
  list: function(options) {
    return this._conn.get('authors/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('authors/'+slug+'/', options)
  }
}

module.exports = Author;


/***/ }),

/***/ 8402:
/***/ (function(module) {



function Category(conn) {
  this._conn = conn;
}

Category.prototype = {
  list: function(options) {
    return this._conn.get('categories/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('categories/'+slug+'/', options)
  }
}

module.exports = Category;


/***/ }),

/***/ 5986:
/***/ (function(module) {



function Content(conn) {
  this._conn = conn;
}

Content.prototype = {
  retrieve: function(keys, options) {
    var keys = keys || [];
    var options = options || {};
    var params = Object.assign({keys: keys.join()}, options);

    return this._conn.get('content/', params)
  }
}

module.exports = Content;


/***/ }),

/***/ 1863:
/***/ (function(module) {



function Feed(conn) {
  this._conn = conn;
}

Feed.prototype = {
  retrieve: function(type, options) {
    return this._conn.get('feeds/'+type+'/', options)
  }
}

module.exports = Feed;


/***/ }),

/***/ 16288:
/***/ (function(module) {



function Page(conn) {
  this._conn = conn;
}

Page.prototype = {
  list: function(page_type, options) {
    return this._conn.get('pages/'+page_type+'/', options)
  },
  retrieve: function(page_type, page_slug, options) {
    return this._conn.get('pages/'+page_type+'/'+page_slug+'/', options)
  },
  search: function(query, options) {
    var options = options || {};
    options.query = query || '';

    return this._conn.get('pages/search/', options)
  }
}

module.exports = Page;

/***/ }),

/***/ 60445:
/***/ (function(module) {



function Post(conn) {
  this._conn = conn;
}

Post.prototype = {
  list: function(options) {
    return this._conn.get('posts/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('posts/'+slug+'/', options)
  },
  search: function(query, options) {
    var options = options || {};
    options.query = query || '';

    return this._conn.get('posts/search/', options)
  }
}

module.exports = Post;


/***/ }),

/***/ 9210:
/***/ (function(module) {



function Tag(conn) {
  this._conn = conn;
}

Tag.prototype = {
  list: function(options) {
    return this._conn.get('tags/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('tags/'+slug+'/', options)
  }
}

module.exports = Tag;


/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 51313:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogoWhite.51bb8a67.svg","height":40,"width":162});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 93157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Header": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useEventListener.js
var useEventListener = __webpack_require__(13704);
;// CONCATENATED MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useScrollTop.js


var isWindowDefined = typeof window !== 'undefined';
/**
 * Returns current scroll top position in pixels.
 *
 * @returns {number} Scroll top position in pixels
 */

function useScrollTop() {
  var _useState = (0,react.useState)(isWindowDefined ? window.pageYOffset : null),
      scrollTop = _useState[0],
      setScrollTop = _useState[1];

  var getScrollTop = (0,react.useCallback)(function () {
    return setScrollTop(window.pageYOffset);
  }, []);
  (0,useEventListener/* default */.Z)(isWindowDefined ? document : null, 'scroll', getScrollTop);
  return scrollTop;
}
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
;// CONCATENATED MODULE: ./src/landingPage/datasets/headerMenu.js

var headerMenu = {
    links: [
        {
            name: "Platform",
            url: linksConstants/* linksConstants.PLATFORM */.s.PLATFORM,
            isNewTab: false
        },
        {
            name: "Documentation",
            url: "https://docs.demyst.com/",
            isNewTab: true
        },
        {
            name: "Discovery",
            url: "https://copilot.demyst.com/",
            isNewTab: true
        },
        {
            name: "Powered By",
            url: linksConstants/* linksConstants.POWERING */.s.POWERING,
            isNewTab: false
        },
        {
            name: "About",
            url: linksConstants/* linksConstants.ABOUT */.s.ABOUT,
            isNewTab: false
        }, 
    ],
    login_button: "Log In",
    login_button_target: linksConstants/* linksConstants.LOGIN */.s.LOGIN,
    platform_button: "Go to Platform",
    platform_button_target: linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG
};

// EXTERNAL MODULE: ./src/landingPage/views/components/LinkButton.jsx
var LinkButton = __webpack_require__(84135);
// EXTERNAL MODULE: ./src/landingPage/views/components/MainCtaButton.jsx
var MainCtaButton = __webpack_require__(11723);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/layouts/LayoutComponents/NavDesktop.jsx




var NavDesktop = function(param) {
    var closeMenu = param.closeMenu, data = param.data, isOpen = param.isOpen, name = param.name, description = param.description;
    var ItemElement = function(param) {
        var item = param.item;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: item.image.src,
                    alt: "",
                    width: "48",
                    height: "48",
                    unoptimized: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "nav_desktop-title",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "nav_desktop-description",
                            children: item.description
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("nav_desktop-background", isOpen && "hover"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            "aria-label": "nav_desktop-main-".concat(name || "main"),
            className: "nav_desktop-main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section-layout",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "nav_desktop-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "nav_desktop-infobox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "nav_desktop-infobox-title",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "nav_desktop-infobox-paragraph",
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "nav_desktop-table",
                            children: [
                                "Resources"
                            ].includes(name) && data.map(function(item) {
                                return item.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "nav_desktop-item",
                                    onClick: function(e) {
                                        return closeMenu(e);
                                    },
                                    href: item.link,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemElement, {
                                        item: item
                                    })
                                }, "desktop-menu-".concat(item.title)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "nav_desktop-item",
                                    href: item.link,
                                    onClick: function(e) {
                                        return closeMenu(e);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemElement, {
                                        item: item
                                    })
                                }, "desktop-menu-".concat(item.title));
                            })
                        })
                    ]
                })
            })
        })
    });
};
NavDesktop.propTypes = {
    closeMenu: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./src/landingPage/datasets/navMobile.js

var navMobile = {
    sections: [
        {
            name: "",
            urlList: [
                {
                    title: "Platform",
                    link: linksConstants/* linksConstants.PLATFORM */.s.PLATFORM,
                    image: ""
                },
                {
                    title: "Documentation",
                    link: "https://docs.demyst.com/o",
                    image: "",
                    external: true
                },
                {
                    title: "Discovery",
                    link: "https://copilot.demyst.com/",
                    image: "",
                    external: false
                },
                {
                    title: "Powered By",
                    link: linksConstants/* linksConstants.POWERING */.s.POWERING,
                    image: ""
                },
                {
                    title: "Resources",
                    link: linksConstants/* linksConstants.RESOURCES */.s.RESOURCES,
                    image: ""
                },
                {
                    title: "About Us",
                    link: linksConstants/* linksConstants.ABOUT */.s.ABOUT,
                    image: ""
                }, 
            ]
        }, 
    ],
    login_button: "Log In",
    login_button_target: linksConstants/* linksConstants.LOGIN */.s.LOGIN,
    platform_button: "Go to Platform",
    platform_button_target: linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG
};

;// CONCATENATED MODULE: ./src/landingPage/assets/svg/CloseButton.svg
/* harmony default export */ var CloseButton = ({"src":"/_next/static/media/CloseButton.3eba706a.svg","height":40,"width":40});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/layouts/LayoutComponents/NavMobile.jsx








var AccordionItem = function(param) {
    var section = param.section, scroll = param.scroll;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var maxHeight = 70 * section.urlList.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                id: "".concat(section.name, "-header"),
                "aria-controls": "".concat(section.name, "-panel"),
                "aria-expanded": isExpanded,
                onClick: function() {
                    return setIsExpanded(!isExpanded);
                },
                className: "nav_mobile-section_title nav_mobile-section_title-button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: section.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiChevronDown */.bTu, {
                        className: (0,clsx_m/* default */.Z)("arrow", isExpanded && "inverted")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "nav_mobile-accordion-body",
                id: "".concat(section.name, "-panel"),
                "aria-labelledby": "".concat(section.name, "-header"),
                "aria-hidden": !isExpanded,
                style: {
                    maxHeight: isExpanded ? "".concat(maxHeight, "px") : 0
                },
                children: section.urlList.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: item.link,
                        className: "nav_mobile-item",
                        onClick: function() {
                            return scroll(item.link);
                        },
                        children: [
                            item.image !== null && item.image.src && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.image.src,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "nav_mobile-section_description",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "nav_mobile-title",
                                    children: item.title
                                })
                            })
                        ]
                    }, "mobile-menu-".concat(item.title));
                })
            })
        ]
    });
};
var NavMobile = function(param) {
    var closeMenu = param.closeMenu, hideMainNav = param.hideMainNav, isUserLoggedIn = param.isUserLoggedIn;
    var scroll = function(link) {
        var current = window.location.pathname;
        if (current === "/platform" && link.indexOf("#") !== -1) {
            var hash = link.slice(link.indexOf("#") + 1);
            var element = document.getElementById(hash);
            if (element !== null) {
                var rect = element.getBoundingClientRect();
                var scrollTop = window.pageYOffset;
                var result = rect.top + scrollTop - 130;
                window.scrollTo({
                    top: result,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }
        closeMenu(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "nav_mobile-background",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "nav_mobile-close",
                onClick: function() {
                    return closeMenu(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: CloseButton.src,
                    alt: "Close menu button",
                    title: "Click here to close the navigation menu",
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "nav_mobile-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "nav_mobile-buttons",
                        children: isUserLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                            section: "NavMobile",
                            href: navMobile === null || navMobile === void 0 ? void 0 : navMobile.platform_button_target,
                            variant: "inverted",
                            children: navMobile === null || navMobile === void 0 ? void 0 : navMobile.platform_button
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                    onClick: closeMenu,
                                    section: "NavMobile",
                                    href: navMobile === null || navMobile === void 0 ? void 0 : navMobile.login_button_target,
                                    variant: "inverted",
                                    children: navMobile === null || navMobile === void 0 ? void 0 : navMobile.login_button
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCtaButton/* MainCtaButton */.T, {
                                    onClick: closeMenu
                                })
                            ]
                        })
                    }),
                    !hideMainNav && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "nav_mobile-sections",
                        children: navMobile === null || navMobile === void 0 ? void 0 : navMobile.sections.map(function(section, sectionIndex) {
                            return !section.isAccordion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "nav_mobile-section",
                                children: [
                                    section.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "nav_mobile-section_title",
                                        children: section.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: section.urlList.map(function(item) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                href: item.link,
                                                className: "nav_mobile-item",
                                                onClick: function() {
                                                    return scroll(item.link);
                                                },
                                                children: [
                                                    ((ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.image.src,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                        className: "nav_mobile-section_description",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "nav_mobile-title",
                                                            children: item.title
                                                        })
                                                    })
                                                ]
                                            }, "mobile-menu-".concat(item.title));
                                        })
                                    })
                                ]
                            }, "nav-mobile-section-".concat(sectionIndex)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav_mobile-section nav_mobile-section-accordion",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, {
                                    section: section,
                                    scroll: scroll
                                })
                            }, "nav-mobile-section-".concat(sectionIndex, "-accordion"));
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/assets/svg/DemystLogo.svg
var DemystLogo = __webpack_require__(79550);
// EXTERNAL MODULE: ./src/landingPage/assets/svg/DemystLogoWhite.svg
var DemystLogoWhite = __webpack_require__(51313);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/header/MenuWhite.svg
/* harmony default export */ var MenuWhite = ({"src":"/_next/static/media/MenuWhite.fc238c83.svg","height":18,"width":24});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/header/MenuBlue.svg
/* harmony default export */ var MenuBlue = ({"src":"/_next/static/media/MenuBlue.47585ded.svg","height":18,"width":24});
;// CONCATENATED MODULE: ./src/landingPage/datasets/headerColors.js





var specialColorSchemes = [
    {
        path: linksConstants/* linksConstants.HOME */.s.HOME,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.BLOGMAIN */.s.BLOGMAIN,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        directory: "blog",
        logo: DemystLogo/* default */.Z,
        links: "blue",
        menu: MenuBlue,
        background: "transparent"
    },
    {
        directory: "third-party-data",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        directory: "external-data",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        directory: "info",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        directory: "lp",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent landing"
    },
    {
        directory: "data-api",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    },
    {
        directory: "webinars",
        background: "transparent",
        logo: DemystLogo/* default */.Z,
        links: "blue",
        menu: MenuBlue
    },
    {
        directory: "industries",
        links: "white",
        logo: DemystLogoWhite/* default */.Z,
        menu: MenuWhite,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.ENTERPRISE */.s.ENTERPRISE,
        links: "white",
        logo: DemystLogoWhite/* default */.Z,
        menu: MenuWhite,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.AWS_CASE_STUDY */.s.AWS_CASE_STUDY,
        logo: DemystLogo/* default */.Z,
        links: "blue",
        menu: MenuBlue,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.CAREERS */.s.CAREERS,
        logo: DemystLogo/* default */.Z,
        links: "blue",
        menu: MenuBlue,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.PLATFORM */.s.PLATFORM,
        links: "white",
        menu: MenuWhite,
        logo: DemystLogoWhite/* default */.Z,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.ABOUT */.s.ABOUT,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.CONTACT */.s.CONTACT,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.REQUEST_DEMO */.s.REQUEST_DEMO,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent landing",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.REPORT */.s.REPORT,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.RELEASES */.s.RELEASES,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "purple",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.WEBINARS */.s.WEBINARS,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.PARTNERS */.s.PARTNERS,
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent",
        button_inverted: false
    },
    {
        path: linksConstants/* linksConstants.ADX_FINCRIME */.s.ADX_FINCRIME,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.ADX_DEMYST_PARTNERSHIP */.s.ADX_DEMYST_PARTNERSHIP,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.ADX_DEMYST_EXCHANGE */.s.ADX_DEMYST_EXCHANGE,
        links: "white",
        logo: DemystLogoWhite/* default */.Z,
        menu: MenuWhite,
        background: "transparent"
    },
    {
        path: linksConstants/* linksConstants.NEWSLETTER */.s.NEWSLETTER,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_KYB */.s.USECASE_KYB,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_KYC */.s.USECASE_KYC,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_PREFILL */.s.USECASE_PREFILL,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_BNPL */.s.USECASE_BNPL,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_DATA_ENRICHMENT */.s.USECASE_DATA_ENRICHMENT,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_LEAD_TARGETING */.s.USECASE_LEAD_TARGETING,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_PORTFOLIO_MONITORING */.s.USECASE_PORTFOLIO_MONITORING,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_CREDIT_BUREAU */.s.USECASE_CREDIT_BUREAU,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.USECASE_BUSINESS_ONBOARDING */.s.USECASE_BUSINESS_ONBOARDING,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.PRICING */.s.PRICING,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite
    },
    {
        path: linksConstants/* linksConstants.DSAR */.s.DSAR,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.CCPA */.s.CCPA,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.MANAGE_COOKIE */.s.MANAGE_COOKIE,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.COOKIE_POLICY */.s.COOKIE_POLICY,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.SUBPROCESSOR_POLICY */.s.SUBPROCESSOR_POLICY,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.TERMS */.s.TERMS,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.PRIVACY */.s.PRIVACY,
        links: "blue",
        menu: MenuBlue,
        background: "transparent",
        logo: DemystLogo/* default */.Z
    },
    {
        path: linksConstants/* linksConstants.RESOURCES */.s.RESOURCES,
        links: "white",
        menu: MenuWhite,
        background: "transparent",
        logo: DemystLogoWhite/* default */.Z
    },
    {
        directory: "platform",
        logo: DemystLogoWhite/* default */.Z,
        links: "white",
        menu: MenuWhite,
        background: "transparent"
    }, 
];

;// CONCATENATED MODULE: ./src/landingPage/assets/svg/header/Menu.svg
/* harmony default export */ var Menu = ({"src":"/_next/static/media/Menu.8ad608b9.svg","height":18,"width":24});
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/landingPage/utils/butter-client.js
var butter_client = __webpack_require__(55894);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/components/Close.svg
/* harmony default export */ var Close = ({"src":"/_next/static/media/Close.ab77045c.svg","height":12,"width":12});
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
;// CONCATENATED MODULE: ./src/landingPage/layouts/LayoutComponents/Banner.jsx








var Banner = function() {
    var ref = (0,react.useState)(null), hidden = ref[0], setHidden = ref[1];
    var ref1 = (0,react.useState)(0), index = ref1[0], setIndex = ref1[1];
    var ref2 = (0,react.useState)([]), headerBannerArray = ref2[0], setHeaderBannerArray = ref2[1];
    (0,react.useEffect)(function() {
        setHidden(sessionStorage.getItem("demystBannerClosed"));
    }, []);
    (0,react.useEffect)(function() {
        if (!hidden) {
            document.getElementsByClassName("layout-main")[0].classList.add("banner-open");
            document.getElementsByClassName("layout-header-full")[0].classList.add("banner-open");
        } else {
            document.getElementsByClassName("layout-main")[0].classList.remove("banner-open");
            document.getElementsByClassName("layout-header-full")[0].classList.remove("banner-open");
        }
    }, [
        hidden
    ]);
    (0,react.useEffect)(function() {
        butter_client/* default.page.retrieve */.Z.page.retrieve("*", "website-banner").then(function(response) {
            var ref;
            var data = response.data.data;
            var headerBanner = data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.header_banner;
            headerBanner.forEach(function(item, i) {
                var buttons = [];
                var _i = headerBanner[i], button_text_1 = _i.button_text_1, button_text_2 = _i.button_text_2, button_url_1 = _i.button_url_1, button_url_2 = _i.button_url_2;
                if (button_text_1 && button_url_1) {
                    buttons.push({
                        text: button_text_1,
                        href: button_url_1
                    });
                }
                if (button_text_2 && button_url_2) {
                    buttons.push({
                        text: button_text_2,
                        href: button_url_2
                    });
                }
                headerBanner[i] = (0,_object_spread/* default */.Z)({
                    buttons: buttons
                }, headerBanner[i]);
            });
            setHidden(headerBanner.length < 1 || sessionStorage.getItem("demystBannerClosed"));
            setHeaderBannerArray(headerBanner);
        }).catch(function(err) {
            console.log(err);
            setHidden(true);
        });
    }, []);
    var savedCallback = (0,react.useRef)();
    var callback = function() {
        var nextIndex = index + 1;
        if (nextIndex >= headerBannerArray.length) nextIndex = 0;
        setIndex(nextIndex);
    };
    (0,react.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react.useEffect)(function() {
        var tick = function() {
            savedCallback.current();
        };
        var id = setTimeout(tick, 5000);
        return function() {
            return clearTimeout(id);
        };
    }, [
        index
    ]);
    if (hidden || headerBannerArray.length === 0) return null;
    var closeBanner = function() {
        setHidden(true);
        sessionStorage.setItem("demystBannerClosed", true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "header_banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "header_banner-page_circle-container",
                children: headerBannerArray.map(function(banner, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setIndex(i);
                        },
                        className: "header_banner-page_circle-button ".concat(i === index ? "active" : ""),
                        "aria-label": "Banner control button ".concat(i)
                    }, banner.text);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header_banner-content",
                    children: headerBannerArray.map(function(banner, i) {
                        if (i === index) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appConfig/* animatePresenceConfig */.Rr), {
                            children: [
                                banner.type === "text-with-buttons" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "header_banner-content-text",
                                            "aria-label": "Banner content",
                                            children: banner.text
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "header_banner-content-button_container",
                                            children: banner.buttons.map(function(button) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "header_banner-content-button_container-button",
                                                    href: button.href,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    "aria-label": "Banner link",
                                                    children: button.text
                                                }, button.text);
                                            })
                                        })
                                    ]
                                }),
                                banner.type === "link" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "header_banner-content-text underline",
                                    href: banner.redirect_url,
                                    "aria-label": "Banner description",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: banner.text
                                })
                            ]
                        }), banner.text);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: closeBanner,
                "aria-label": "Close banner",
                className: "header_banner-close_icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: Close.src,
                    alt: "Close",
                    title: "Close this banner",
                    height: "12",
                    width: "12",
                    loading: "eager"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/hooks/usePathChange.js
var usePathChange = __webpack_require__(2679);
// EXTERNAL MODULE: ./src/redux/Provider.js
var Provider = __webpack_require__(66884);
;// CONCATENATED MODULE: ./src/landingPage/layouts/LayoutComponents/Header.jsx
















var Header = function(param) {
    var _showBanner = param.showBanner, showBanner = _showBanner === void 0 ? true : _showBanner, _showNav = param.showNav, showNav = _showNav === void 0 ? true : _showNav;
    var pathname = (0,usePathChange/* default */.Z)();
    var scrollTop = useScrollTop();
    var user = (0,Provider/* useUser */.a)();
    var isUserLoggedIn = user && !!user.user;
    var ref = (0,react.useState)(false), mobileNavOpen = ref[0], changeMobileNavOpen = ref[1];
    var ref1 = (0,react.useState)(false), isPlatformMenuOpen = ref1[0], setIsPlatformMenuOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isResourcesMenuOpen = ref2[0], setIsResourcesMenuOpen = ref2[1];
    var isLanding = !showNav;
    var isScrolledTop = scrollTop === 0;
    var specialColorScheme = specialColorSchemes.find(function(param) {
        var path = param.path, directory = param.directory;
        if (path) return path === pathname;
        if (!path && directory) return pathname.startsWith("/".concat(directory, "/"));
        return false;
    });
    var allMenusClosed = !isResourcesMenuOpen && !isPlatformMenuOpen;
    var headerBackground = allMenusClosed && isScrolledTop && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.background);
    var logo = allMenusClosed && isScrolledTop && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.logo);
    var menu = allMenusClosed && isScrolledTop && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.menu);
    var linkColor = allMenusClosed && isScrolledTop && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.links);
    var buttonInverted = allMenusClosed && isScrolledTop && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.button_inverted);
    var openMenu = function(event) {
        if (event.currentTarget.getAttribute("data-name") === "Resources") {
            setIsResourcesMenuOpen(true);
        } else if (event.currentTarget.getAttribute("data-name") === "Platform") {
            setIsPlatformMenuOpen(true);
        }
    };
    var closeMenu = function(e) {
        e.persist();
        setIsResourcesMenuOpen(false);
        setIsPlatformMenuOpen(false);
    };
    var isLinkActive = function(link) {
        if (link.url) {
            if (link.url === pathname) return true;
        }
        if (link.urlList) {
            var availableLinks = link.urlList.map(function(l) {
                return l.link;
            });
            if (availableLinks.includes(pathname)) return true;
        }
        if (link.items) {
            var availableLinks1 = link.items.map(function(item) {
                return item.urlList.map(function(l) {
                    return l.link;
                });
            }).flat(1);
            if (availableLinks1.includes(pathname)) return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (0,clsx_m/* default */.Z)("layout-header-full", isLanding && "layout-header-full-landing"),
            children: [
                showBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("layout-header-full-header", !isLanding && headerBackground, isLanding && (specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.background), isScrolledTop && "on-top"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "section-layout",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "layout-header-main",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    className: "layout-header-logo",
                                    title: "Return home",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: !isLanding ? (logo === null || logo === void 0 ? void 0 : logo.src) || DemystLogo/* default.src */.Z.src : specialColorScheme === null || specialColorScheme === void 0 ? void 0 : specialColorScheme.logo.src,
                                        className: "layout-header-logo-img",
                                        alt: "Demyst",
                                        loading: "eager",
                                        height: "40",
                                        width: "162"
                                    })
                                }),
                                !isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "layout-header-nav",
                                    children: headerMenu.links.map(function(link) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            "data-name": link.name,
                                            className: (0,clsx_m/* default */.Z)("layout-header-nav-item", isLinkActive(link) && "layout-header-nav-item--active"),
                                            onMouseEnter: openMenu,
                                            onMouseLeave: closeMenu,
                                            children: link.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.url,
                                                className: (0,clsx_m/* default */.Z)("layout-header-link", linkColor),
                                                target: link.isNewTab ? "_blank" : "_self",
                                                dangerouslySetInnerHTML: {
                                                    __html: link.name
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: (0,clsx_m/* default */.Z)("layout-header-link", linkColor),
                                                        dangerouslySetInnerHTML: {
                                                            __html: link.name + " ▾"
                                                        },
                                                        href: link.defaultUrl,
                                                        onClick: closeMenu
                                                    }),
                                                    link.name === "Resources" && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDesktop, {
                                                        name: link.name,
                                                        description: link.description,
                                                        data: link.urlList,
                                                        closeMenu: closeMenu,
                                                        isOpen: isResourcesMenuOpen
                                                    })
                                                ]
                                            })
                                        }, link.name);
                                    })
                                }),
                                !isLanding && (isUserLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "layout-header-buttons",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                        variant: !buttonInverted ? "inverted" : "primary",
                                        href: headerMenu.platform_button_target,
                                        autoWidth: true,
                                        size: "md",
                                        children: headerMenu.platform_button
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "layout-header-buttons",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                            variant: !buttonInverted ? "inverted" : "primary",
                                            section: "Header",
                                            href: headerMenu.login_button_target,
                                            autoWidth: true,
                                            size: "md",
                                            children: headerMenu.login_button
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCtaButton/* MainCtaButton */.T, {
                                            autoWidth: true,
                                            size: "md"
                                        })
                                    ]
                                })),
                                !isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "layout-header-menu",
                                    onClick: function() {
                                        return changeMobileNavOpen(true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (menu === null || menu === void 0 ? void 0 : menu.src) || Menu.src,
                                        alt: "Menu",
                                        height: "18",
                                        width: "24",
                                        title: "Click to open menu",
                                        loading: "eager"
                                    })
                                }),
                                mobileNavOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMobile, {
                                    isUserLoggedIn: isUserLoggedIn,
                                    closeMenu: changeMobileNavOpen
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 55894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var buttercms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46676);
/* harmony import */ var buttercms__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(buttercms__WEBPACK_IMPORTED_MODULE_0__);

function shouldRetry(config) {
    config["__custom_retry_handling__"] = config["__custom_retry_handling__"] || {
        retries: 0
    };
    if (config["__custom_retry_handling__"].retries < 3) {
        config["__custom_retry_handling__"].retries += 1;
        return true;
    } else {
        return false;
    }
}
// stolen from: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L109
// and from: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L234
function fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) {
        delete config.agent;
    }
    if (axios.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axios.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
    config.transformRequest = [
        function(data) {
            return data;
        }
    ];
}
function axiosHook(axios) {
    axios.interceptors.response.use(function(response) {
        return response;
    }, function(error) {
        var config = error.config;
        if (!config) {
            var ref;
            // idk what would cause this to go missing, but they handle it so we should, too
            // ref: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L207-L209
            console.info("error from buttercms: ".concat(error, " (").concat((ref = error.config) === null || ref === void 0 ? void 0 : ref.url, ")"));
            return Promise.reject(error);
        }
        if (shouldRetry(config)) {
            var ref1;
            fixConfig(axios, config);
            console.info("error from buttercms: ".concat(error, " (").concat((ref1 = error.config) === null || ref1 === void 0 ? void 0 : ref1.url, "). retrying..."));
            return axios(config);
        } else {
            var ref2;
            console.info("error from buttercms: ".concat(error, " (").concat((ref2 = error.config) === null || ref2 === void 0 ? void 0 : ref2.url, ")"));
            return Promise.reject(error);
        }
    });
}
var butter = buttercms__WEBPACK_IMPORTED_MODULE_0___default()("db35569d3bb3739cf02d32a74a1b5f6dc6243d57", false, 12000, axiosHook);
/* harmony default export */ __webpack_exports__["Z"] = (butter);


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        },
        isExternal: isExternal
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ })

}]);